// Columbia's undergraduate majors (#2652). Read on 2026-10-01 from two
// official pages: Columbia College's "Majors, Minors, and Special Programs"
// list (college.columbia.edu/academics/programs; every major leads to the
// Bachelor of Arts) and Columbia Undergraduate Admissions' Columbia
// Engineering "Areas of Study" majors list (every Columbia Engineering major
// leads to the Bachelor of Science, per the Columbia Engineering Bulletin).
// Minors, special programs, pre-Fall 2024 concentrations, the School of
// General Studies (its own admissions) and graduate programs are left out.
// Quirks: the College page cuts one name short ("German Literature &
// Cultural"); it is given in full, as the same page's concentration list and
// the Bulletin name it. Em dashes in joint majors become hyphens. The KB's
// majors list was the starting point; the official pages win.
const majors = {
    "slug": "columbia-university",
    "read": "2026-10-01",
    "intro": "Every undergraduate major Columbia lists for Columbia College and Columbia Engineering, the two schools that take first-year applicants, with the degree it leads to. Minors, special programs, the School of General Studies and graduate programs are left out.",
    "groups": [
        {
            "name": "Columbia College",
            "source": {
                "label": "Columbia College, Majors, Minors, and Special Programs",
                "url": "https://www.college.columbia.edu/academics/programs"
            },
            "majors": [
                {
                    "name": "African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Archaeology",
                    "degree": "BA"
                },
                {
                    "name": "Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Art History & Visual Arts",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astrophysics",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biophysics",
                    "degree": "BA"
                },
                {
                    "name": "Chemical Physics",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Climate and Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Climate System Science",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature and Society",
                    "degree": "BA"
                },
                {
                    "name": "Computational Biology",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science-Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Creative Writing",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BA"
                },
                {
                    "name": "Drama and Theatre Arts",
                    "degree": "BA"
                },
                {
                    "name": "Earth Science",
                    "degree": "BA"
                },
                {
                    "name": "East Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics-Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Economics-Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Economics-Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Economics-Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Education Studies",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Biology",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BA"
                },
                {
                    "name": "Ethnicity and Race Studies",
                    "degree": "BA"
                },
                {
                    "name": "Evolutionary Biology of the Human Species",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Financial Economics",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French & Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "German Literature & Cultural History",
                    "degree": "BA"
                },
                {
                    "name": "Global Affairs and Public Policy",
                    "degree": "BA"
                },
                {
                    "name": "Hispanic Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History and Theory of Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Human Rights",
                    "degree": "BA"
                },
                {
                    "name": "Information Science",
                    "degree": "BA"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Latin American and Caribbean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics-Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Medical Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Middle Eastern, South Asian & African Studies",
                    "degree": "BA"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience & Behavior",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science-Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Regional Studies",
                    "degree": "BA"
                },
                {
                    "name": "Religion",
                    "degree": "BA"
                },
                {
                    "name": "Russian Language & Culture",
                    "degree": "BA"
                },
                {
                    "name": "Russian Literature & Culture",
                    "degree": "BA"
                },
                {
                    "name": "Slavic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Sustainable Development",
                    "degree": "BA"
                },
                {
                    "name": "Urban Studies",
                    "degree": "BA"
                },
                {
                    "name": "Visual Arts",
                    "degree": "BA"
                },
                {
                    "name": "Women's & Gender Studies",
                    "degree": "BA"
                },
                {
                    "name": "Yiddish Studies",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Columbia Engineering (The Fu Foundation School of Engineering and Applied Science)",
            "source": {
                "label": "Columbia Undergraduate Admissions, Columbia Engineering, Areas of Study",
                "url": "https://undergrad.admissions.columbia.edu/academics/engineering/majors"
            },
            "note": "Two teacher recommendations are required, and one of them must come from a math or science teacher.",
            "noteSource": "firstYear",
            "majors": [
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Decision Science and Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mining Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Operations Research",
                    "degree": "BS"
                },
                {
                    "name": "Quantitative Finance and Financial Technology",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
